// extracted by mini-css-extract-plugin
export var header = "PageHeader-module__header___RCGLt";
export var headerContent = "PageHeader-module__headerContent___-R+sv";
export var heading = "PageHeader-module__heading___KMbe0";